export class RestApiRequestHeaderConfiguration {
    public key: string;
    public value: string;

    /**
     * Retourne une copie d'une instance de RestApiRequestHeaderConfiguration
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: RestApiRequestHeaderConfiguration) {
        if (!!other) {
            const instance = new RestApiRequestHeaderConfiguration();

            instance.key = other.key;
            instance.value = other.value;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de RestApiRequestHeaderConfiguration
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: RestApiRequestHeaderConfiguration[]) {
        if (!!others) {
            let headers: RestApiRequestHeaderConfiguration[] = [];

            others.forEach((x) => {
                const header = RestApiRequestHeaderConfiguration.clone(x);
                headers.push(header);
            });

            return headers;
        } else {
            return [];
        }
    }
}
